export const ROLES_LIST_ALL = "ROLES_LIST_ALL";
export const ROLES_LIST_ALL_SUCCESS = "ROLES_LIST_ALL_SUCCESS";
export const ROLES_LIST_ALL_ERROR = "ROLES_LIST_ALL_ERROR";
export const MENU_ITEMS = "MENU_ITEMS";
export const MENU_ITEMS_SUCCESS = "MENU_ITEMS_SUCCESS";
